import React, { useState, useMemo } from 'react';
import countryList from 'react-select-country-list';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ContactBackImg from './images/contactimg.webp';
import './css/contactus.css';
import { useLanguage } from '../context/LanguageContext';
import { contactAPI } from '../services/apiService';

const ContactUs = () => {
    const { t } = useLanguage();
    const [country, setCountry] = useState(null);
    const [phone, setPhone] = useState('');
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        activity: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const options = useMemo(() => countryList().getData(), []);

    const changeHandler = value => {
        setCountry(value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            await contactAPI.submit({
                ...formData,
                phone: phone
            });

            setSubmitStatus('success');
            setFormData({
                fullName: '',
                email: '',
                activity: '',
                message: ''
            });
            setPhone('');
            setCountry(null);
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };
    
    return (
        <section id="contact-section" className='contact-us'>
            <img className='back-img' src={ContactBackImg} alt="Contact us background" />
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 col-12'></div>
                    <div className='col-lg-6 col-12'>
                        <div className='contact-form'>
                            <h1> {t('contactUs.title')} </h1>
                            
                            {submitStatus === 'success' && (
                                <div className="alert alert-success">
                                    Thank you! Your message has been sent successfully.
                                </div>
                            )}
                            
                            {submitStatus === 'error' && (
                                <div className="alert alert-error">
                                    Sorry, there was an error sending your message. Please try again.
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className='input'>
                                    <label htmlFor="fullName"> {t('contactUs.fullName')} </label>
                                    <input 
                                        type='text' 
                                        id="fullName" 
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        placeholder={t('contactUs.fullNamePlaceholder')} 
                                        required 
                                        aria-label={t('contactUs.fullName')}
                                    />
                                </div>

                                <div className='input'>
                                    <label htmlFor="emailAddress"> {t('contactUs.emailAddress')} </label>
                                    <input 
                                        type='email' 
                                        id="emailAddress" 
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder={t('contactUs.emailPlaceholder')} 
                                        required 
                                        aria-label={t('contactUs.emailAddress')}
                                    />
                                </div>

                                <div className='input'>
                                    <label htmlFor="phoneNumber"> {t('contactUs.phoneNumber')} </label>
                                    <PhoneInput
                                        country={'us'}
                                        value={phone}
                                        onChange={setPhone}
                                        enableSearch={true}
                                        placeholder={t('contactUs.phonePlaceholder')}
                                        aria-label={t('contactUs.phoneNumber')}
                                    />
                                </div>

                                <div className='input'>
                                    <label htmlFor="activity"> {t('contactUs.activity')} </label>
                                    <input 
                                        type='text' 
                                        id="activity" 
                                        name="activity"
                                        value={formData.activity}
                                        onChange={handleInputChange}
                                        placeholder={t('contactUs.activityPlaceholder')} 
                                        required 
                                        aria-label={t('contactUs.activity')}
                                    />
                                </div>

                                <div className='input'>
                                    <label htmlFor="message"> {t('contactUs.message')} </label>
                                    <textarea 
                                        id="message" 
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        placeholder="Enter your message here..."
                                        required 
                                        aria-label={t('contactUs.message')}
                                        rows="4"
                                    />
                                </div>

                                <button 
                                    type="submit" 
                                    className="submit-btn" 
                                    aria-label="Submit contact form"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Sending...' : t('contactUs.submit')}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactUs
